module.exports = __webpack_public_path__ + "static/media/claws.60791ef4.png";